import { fg } from '@atlassian/jira-feature-gating';
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import type { Action } from '@atlassian/react-sweet-state';
import type { State, Attributes } from './types.tsx';

const PRODUCTS = ['jira'];

const loadRecentActivities =
	(): Action<State, Attributes> =>
	async ({ setState }, meta) => {
		setState({
			isFetching: true,
			fetchError: null,
		});

		try {
			const filter = fg('blu-3344-worked-on-menu-fix')
				? // Match the logic from the corresponding Your Work page so they show the same results (/global-pages/home/src/services/recent-activity-provider/index.tsx)
					{
						limit: 10,
						rootContainerIds: [`ari:cloud:platform::site/${meta.cloudId}`],
						products: PRODUCTS,
					}
				: {
						limit: 10,
						rootContainerIds: [`ari:cloud:platform::site/${meta.cloudId}`],
						objectTypes: ['issue'],
						products: PRODUCTS,
					};

			const promise = meta.activityClient.fetchActivities([50, 125, 250], filter, ['workedOn']);

			setState({ promise });

			const activityItems = await promise;

			setState({ hasSuccessOnce: true, items: activityItems, isFetching: false });
			// eslint-disable-next-line @typescript-eslint/no-explicit-any
		} catch (error: any) {
			setState({ isFetching: false, fetchError: error });
		}
	};

export const actions = { loadRecentActivities } as const;
